import { render, staticRenderFns } from "./customer-behavior-item.vue?vue&type=template&id=5c8a8d0c&scoped=true"
import script from "./customer-behavior-item.vue?vue&type=script&lang=js"
export * from "./customer-behavior-item.vue?vue&type=script&lang=js"
import style0 from "./customer-behavior-item.vue?vue&type=style&index=0&id=5c8a8d0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a8d0c",
  null
  
)

export default component.exports